module.exports = __webpack_public_path__ + "img/shahr.95b8849.png";